import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const OPEN_EDIT_FORM_REFERENCE_MODAL = 'OPEN_EDIT_FORM_REFERENCE_MODAL';
export const CLOSE_EDIT_FORM_REFERENCE_MODAL = 'CLOSE_EDIT_FORM_REFERENCE_MODAL';
export const CLOSE_EDIT_FORM_REFERENCE_ERROR = 'CLOSE_EDIT_FORM_REFERENCE_ERROR';
export const GET_FORM_REFERENCE_REQUEST = 'GET_FORM_REFERENCE_REQUEST';
export const GET_FORM_REFERENCE_SUCCESS = 'GET_FORM_REFERENCE_SUCCESS';
export const GET_FORM_REFERENCE_ERROR = 'GET_FORM_REFERENCE_ERROR';

function openModal(currentForm) {
  return {
    type: OPEN_EDIT_FORM_REFERENCE_MODAL,
    isEditFormReferenceModalShown: true,
    currentForm
  };
}

function closeModal() {
  return {
    type: CLOSE_EDIT_FORM_REFERENCE_MODAL,
    isEditFormReferenceModalShown: false,
    editFormReferenceResponse: null,
    editFormReference: null
  };
}

function closeError() {
  return {
    type: CLOSE_EDIT_FORM_REFERENCE_ERROR,
    isEditFormReferenceModalShown: true
  };
}

function request() {
  return {
    type: GET_FORM_REFERENCE_REQUEST
  };
}

function receive(formData) {
  return {
    type: GET_FORM_REFERENCE_SUCCESS,
    formData
  };
}

function reject() {
  return {
    type: GET_FORM_REFERENCE_ERROR
  };
}

export function getFormReference(id, formType) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .getFormById(formType, id)
      .then(response => dispatch(receive(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}

export function showEditFormReferenceModal(item) {
  return (dispatch) => {
    if (item && item.length === 1) {
      dispatch(getFormReference(item[0].id, item[0].formType));
    }
    return dispatch(openModal(item));
  };
}

export function hideEditFormReferenceModal() {
  return (dispatch) => {
    dispatch(closeModal());
  };
}

export function hideEditFormReferenceError() {
  return (dispatch) => {
    dispatch(closeError());
  };
}
